import { render, staticRenderFns } from "./SendAftercareEmail.vue?vue&type=template&id=4a450103&"
import script from "./SendAftercareEmail.vue?vue&type=script&lang=js&"
export * from "./SendAftercareEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports